import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * This is a snapshot of the passive data harverested from mobiles.
 * This snapshot is created every day by a rule.
 *
 * The data a grouped by days and nights.
 * days is from 8am to 7h59pm
 * nights is form 8pm to 7h59am
 * Each frame as a occurred At (at 12am of 12pm ) and the value of steps, activations and visits of the total day or night.
 */
export default class MobilePassiveDataDailySnapshotJournalEvent extends JournalEvent {
  static override type = "mobile-passive-data-daily-snapshot-journal-event";

  /**
   * The number of steps the patient did.
   */
  @attr() declare steps: any;

  /**
   * The number of visits the patient did.
   */
  @attr() declare visits: any;

  /**
   * The number of device activations the patient did.
   */
  @attr() declare activations: any;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.mobile-passive-data-daily-snapshot-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "mobilePassiveDataDailySnapshotJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "mobile-passive-data-daily-snapshot-journal-event": MobilePassiveDataDailySnapshotJournalEvent;
  }
}
